import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AnotaButtonModule } from '@githubanotaai/design-system';
import { InformationsForm } from '../main-form/forms/informations/form/informations-form.form';
import { environment } from '@env/environment';
import { ShouldHandleInformationsAction } from '@actions/main-form/should-handle-informations.action';

const LANDING_PAGE_URL = environment.landingPageUrl;

@Component({
  standalone: true,
  selector: 'not-found',
  styleUrl: 'not-found.component.scss',
  templateUrl: 'not-found.component.html',
  imports: [RouterModule, AnotaButtonModule],
})
export class NotFoundComponent {
  private shouldHandleInformationsAction = inject(ShouldHandleInformationsAction);
  private router = inject(Router);
  private informationsForm = inject(InformationsForm);

  continue() {
    const values = this.informationsForm.asFormGroup.getRawValue();

    if (this.shouldHandleInformationsAction.run()) {
      this.router.navigate(['/steps/informations']);
      return;
    }

    if (values.deal_id) {
      this.router.navigate(['/steps/credentials']);
      return;
    }

    window.location.href = LANDING_PAGE_URL;
  }
}
